import React from 'react';

import FieldText from '../commons/FieldText';
import FieldNumber from '../commons/FieldNumber';

const PersonalData = () => {
  const ID_MARITAL_STATUS_BY_DEFAULT = 5;
  const ID_OCCUPATION_BY_DEFAULT = 1005;

  return (
    <div>
      <h3>Datos personales</h3>
      <hr className="solid" />
      <div className="field-row">
        <FieldText
          label="Email"
          name="email"
          required />
        <div className="field -double-input">
          <FieldText
            maxLength={10}
            label="Teléfono celular"
            name="cellphone"
            placeholder="000 0000 0000"
            className="field -input -half"
            required />
        </div>
      </div>
      <div>
        <div className="field -double-input">
          <FieldNumber
            label="Estado civil"
            required
            className="field -input -half"
            keyLabel="name"
            keyName="id"
            valueDefinied={ID_MARITAL_STATUS_BY_DEFAULT}
            name="maritalStatus"
            disabled
            hidden />
        </div>
        <FieldNumber
          label="Ocupación"
          required
          keyLabel="name"
          keyName="id"
          valueDefinied={ID_OCCUPATION_BY_DEFAULT}
          name="occupation"
          disabled
          hidden />
      </div>
    </div>
  );
};

export default PersonalData;
